import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Paper,
  useMediaQuery,
  Box,
  Modal,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch } from "react-redux";
import { Set_SalesInvoice_HeadObject_Set } from "../SliceSalesInvoice";
import { SalesInvoiceRo } from "../../../Redux/roStore";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import { SalesInvoice001_Loyalty_Search_Getrow } from "../../../Server/ApiV2";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";

function LoyaltySearch({
  open = false,
  fCloseSearchModal = () => {},
  xTitle = "Modal",
}) {
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  const dispatch = useDispatch();
  const [row, setrow] = useState([]);
  const [column, setColumn] = useState([
    {
      field: "UId",
      headerName: "UId",
      hide: false,
      width: 100,
      align: "left",
      headerAlign: "left",
      Typ: " ",
      NumberFormat: "",
    },
    {
      field: "SName",
      headerName: "SName",
      hide: false,
      width: 100,
      align: "left",
      headerAlign: "left",
      Typ: " ",
      NumberFormat: "",
    },
    {
      field: "CustGrp",
      headerName: "CustGrp",
      hide: false,
      width: 80,
      align: "left",
      headerAlign: "left",
      Typ: " ",
      NumberFormat: "",
    },
    {
      field: "GroupName",
      headerName: "GroupName",
      hide: false,
      width: 80,
      align: "left",
      headerAlign: "left",
      Typ: " ",
      NumberFormat: "",
    },
    {
      field: "Mobile",
      headerName: "Mobile",
      hide: false,
      width: 100,
      align: "left",
      headerAlign: "left",
      Typ: " ",
      NumberFormat: "",
    },
    {
      field: "Active",
      headerName: "Active",
      hide: false,
      width: 80,
      align: "left",
      headerAlign: "left",
      Typ: " ",
      NumberFormat: "",
    },
    {
      field: "CustSrNo",
      headerName: "CustSrNo",
      hide: false,
      width: 80,
      align: "left",
      headerAlign: "left",
      Typ: " ",
      NumberFormat: "",
    },
  ]);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    middleName: "",
    customerCode: "",
    mobile: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleClear = () => {
    setFormData({
      firstName: "",
      lastName: "",
      middleName: "",
      customerCode: "",
      mobile: "",
    });
    setrow([])
  };

  const handleLoad = async () => {
    let obj = {
      v_UId: formData.customerCode,
      v_FName: formData.firstName,
      v_MName: formData.middleName,
      v_LName: formData.lastName,
      v_Mobile: formData.mobile,
    };

    let resp = await SalesInvoice001_Loyalty_Search_Getrow(
      fcheck_null_undefine_replace_empty(obj)
    ); 
    if (resp?.status === 200) {
      console.log(resp);
      let respData = resp?.data?.ResultSet; 
      let data = respData.length == 0 ?[]:respData.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setrow(data);
    } else {
      setrow([]);
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in SalesInvoice001_Loyalty_Search_Getrow "
        );
      }
    }
  };

  const fCheckKey = (event) => {
    if (event.keyCode === 13) {
      // Enter key is pressed
      handleLoad();
    } else if (event.keyCode === 40 && row?.length > 0) {
      // Down arrow key is pressed
      var selectedLength =
        document.getElementsByClassName("Mui-selected").length;
      if (selectedLength === 0) {
        let tabel = document.getElementById("table-main-grid-4");
        tabel
          ?.getElementsByClassName("MuiDataGrid-row")[0]
          .firstChild?.focus();
      }
    }
  };

  const handleCancel = () => {
    // Implement cancel logic if needed
    console.log("Cancelled");
    fCloseSearchModal();
  };
  useEffect(() => {
    if (open) {
      handleLoad();
    }
  }, [open]);
  return (
    <Modal
      open={open}
      onClose={fCloseSearchModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="container-fluid">
        <Box sx={{ overflow: "auto" }} className="model-GCSearchBtn">
          <GCTitleSticky title={xTitle} onClose={fCloseSearchModal} />

          <Paper style={{ padding: "20px" }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="First Name"
                      size="small"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      onKeyUp={fCheckKey}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Customer Code"
                      size="small"
                      name="customerCode"
                      value={formData.customerCode}
                      onChange={handleChange}
                      onKeyUp={fCheckKey}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Last Name"
                      size="small"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      onKeyUp={fCheckKey}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Mobile"
                      size="small"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      onKeyUp={fCheckKey}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Middle Name"
                      size="small"
                      name="middleName"
                      value={formData.middleName}
                      onChange={handleChange}
                      onKeyUp={fCheckKey}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    container
                    justifyContent="flex-end"
                    spacing={2}
                  >
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleLoad}
                      >
                        Load
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleClear}
                      >
                        Clear
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <div
                  style={{
                    height: vMediaQuery ? "45vh" : "53vh",
                    width: "100%",
                  }}
                  id="table-main-grid-4"
                >
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                    }}
                    rows={row}
                    columns={column}
                    onCellKeyDown={(newSelectionModel, e) => {
                      if (e.key === "Enter") {
                        let { HeadObject } = SalesInvoiceRo();
                        //   fGCSearchBtn_OnRowClick(newSelectionModel);
                        dispatch(
                          Set_SalesInvoice_HeadObject_Set({
                            ...HeadObject,
                            LoyaltyCd:e?.row?.UId,
                            LoyaltyName: e?.row?.FName,
                          })
                        ); 
                        fCloseSearchModal()
                        handleClear()
                      }
                    }}
                    onRowClick={(e) => {
                      let { HeadObject } = SalesInvoiceRo();
                      dispatch(
                        Set_SalesInvoice_HeadObject_Set({
                          ...HeadObject,
                          LoyaltyCd: e?.row?.UId,
                          LoyaltyName: e?.row?.FName,
                        })
                      );
                      handleClear()
                      fCloseSearchModal()
                    }}
                    hideFooter={row.length < 100}
                  />
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </div>
    </Modal>
  );
}

export default LoyaltySearch;
